import {
    UPDATE_PAYMENT_DETAILS,
    UPDATE_PAYMENT_DETAILS_ERROR,
    UPDATE_PAYMENT_DETAILS_SUCCESS,
    UPDATE_PAYMENT_DETAILS_INITIAL,
    UpdatePaymentAction,
    UpdatePaymentState,
} from '../_types/updatePayment';

const initialState: UpdatePaymentState = {
    data: null,
    loading: false,
    error: null,
};

export default (state = initialState, action: UpdatePaymentAction): UpdatePaymentState => {
    switch (action.type) {
        case UPDATE_PAYMENT_DETAILS_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: null,
            };
        case UPDATE_PAYMENT_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case UPDATE_PAYMENT_DETAILS_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case UPDATE_PAYMENT_DETAILS_INITIAL:
            return initialState;
        default:
            return state;
    }
};
